"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlTabLayoutPillDefaultContent", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tlTabLayout",
    template: '' + '<div class="ts-tab-pill-content">' + '   <i ng-show="tab.icon" class="fa {{tab.icon}}"></i>' + '   <h1>{{ tab.label || (tab.labelKey | translate) }}</h1>' + '</div>',
    link: function link($scope, $el, $attrs, tabLayoutCtrl) {
      var tab = $scope.tab;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tabset/tlTabLayoutPillDefaultContent.js
// module id = 3011
// module chunks = 13